import OfferingForm from './OfferingForm';

export default OfferingForm;
